import React from 'react';

import { Box } from '@rover/kibble/core';
import LoadingShimmer from '@rover/kibble/patterns/LoadingShimmer';

const SkillsFormShimmer = (): JSX.Element => (
  <Box data-testid="skills-form-shimmer">
    <LoadingShimmer width="100%" height={14} mb="6x" mx="0x" />

    <Box mb="6x">
      <LoadingShimmer width={100} height={16} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={40} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={40} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={40} mx="0x" />
    </Box>

    <Box mb="6x">
      <LoadingShimmer width={100} height={16} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={40} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={40} mx="0x" />
    </Box>

    <LoadingShimmer width="100%" height={44} mx="0x" />
  </Box>
);

export default SkillsFormShimmer;
